var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcMicOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2821 13.9679H19.7564C19.7564 14.642 19.6128 15.2705 19.3705 15.8353L20.4744 16.9558C20.9769 16.0631 21.2821 15.0519 21.2821 13.9679ZM17.6744 14.1228C17.6744 14.0681 17.6923 14.0226 17.6923 13.9679V8.50233C17.6923 6.99018 16.4898 5.76953 15 5.76953C13.5103 5.76953 12.3077 6.99018 12.3077 8.50233V8.66629L17.6744 14.1228ZM8.06284 6.68046L6.9231 7.83735L12.3167 13.312V13.9679C12.3167 15.4801 13.5103 16.7007 15 16.7007C15.1975 16.7007 15.3949 16.6734 15.5834 16.6278L17.0731 18.14C16.4359 18.4406 15.7269 18.6137 15 18.6137C12.5231 18.6137 10.2436 16.7007 10.2436 13.9679H8.71797C8.71797 17.0742 11.159 19.643 14.1026 20.0894V23.0772H15.8975V20.0894C16.7141 19.9709 17.4859 19.6795 18.1769 19.2695L21.9372 23.0772L23.0769 21.9203L8.06284 6.68046Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMicOff);
export default __webpack_public_path__ + "static/media/ic-mic-off.9b49ae3bd95829143709dc96624bcb1c.svg";
export { ForwardRef as ReactComponent };